export const VideoKYCStatusEnum = {
    Completed:"Completed",
    Approved:"Approved",
    Pending:"Pending",
    Rejected:"Rejected",
    Pass:"Pass",
    Fail:"Fail",
    capture_pending:"capture_pending",
    Verified:"Verified"
  };
  